/**
* Long Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Long Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'long-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.quote-form .gform_page:first-child' ).addClass( 'current-page' ).attr( 'tabindex', '0' );
      document.querySelectorAll( '.gform_page' ).forEach( ( el, idx ) => {
        const div = document.createElement( 'div' );
        div.classList.add( 'pagination_dot' );
        if ( idx == 0 ) {
          div.classList.add( 'active' );
        }
        div.innerText = idx + 1;
        document.querySelector( '.long-form__pagination' ).append( div );
      } );

      const next = document.querySelector( '.quote-form .gform_next_button' );
      next.classList.add( 'btn' );
      next.classList.add( 'btn-dark' );
      next.value = 'Continue';

      // Page change stuff
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        // const progress = currentPage / totalPages;
        // $( '.quoter .progress-bar .progress' ).css( {
        //   '-webkit-transform': 'scaleX(' + progress + ')',
        //   'transform': 'scaleX(' + progress + ')',
        // } );

        // Create pagination and dots
        const dots = document.querySelectorAll( '.pagination_dot' );
        const nextBtn = document.querySelectorAll( '.quote-form .gform_next_button' );
        const prevBtn = document.querySelectorAll( '.quote-form .gform_previous_button' );
        if ( nextBtn[currentPage - 1] ) {
          nextBtn[currentPage - 1].classList.add( 'btn' );
          nextBtn[currentPage - 1].classList.add( 'btn-dark' );
          nextBtn[currentPage - 1].value = 'Continue';
        }
        if ( prevBtn[currentPage - 2] ) {
          prevBtn[currentPage - 2].value = '←';
        }

        // Check to see which page is the current page and highlight correct dot
        document.querySelectorAll( '.gform_page' ).forEach( ( el, idx ) => {
          if ( el.style.display != 'none' ) {
            dots[idx].classList.add( 'active' );
          } else {
            dots[idx].classList.remove( 'active' );
          }
        } );

        // Hide or show continue button
        if ( $( '.gform_page' )[currentPage - 1].classList.contains( 'radio-page' ) && currentPage != 7 ) {
          $( '.gform_next_button' )[currentPage - 1].style.visibility = 'hidden';
        } else if ( $( '.gform_next_button' )[currentPage - 1] ) {
          $( '.gform_next_button' )[currentPage - 1].style.visibility = 'visible';
        }

        // Set current page, scroll to top
        $( '.quote-form .gform_page' ).removeClass( 'current-page' );
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'current-page' ).attr( 'tabindex', '0' );
        $( '.current-page' ).focus();
        $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );

        if ( $( '#gform_submit_button_3' ) && currentPage == 7 ) {
          $( '#gform_submit_button_3' ).addClass( 'btn-dark' );
        }
      } );

      // If long form has submitted, hide pagination
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        if ( formId == 3 ) {
          const pagination = document.querySelector( '.long-form__pagination' );
          pagination.style.display = 'none';
        }
      } );

      $( document ).on( 'click', '.radio-page input[type="radio"]', function() {
        $( '.current-page .gform_next_button' ).trigger( 'click' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'long-form', COMPONENT );
} )( app );
